const resource = {

  ar: {
    translation: {
      Welcome: "تسجيل دخول",
      Email_Input: "ادخل الايميل",
      Password_Input: "ادخل كلمة المرور",
      Error_Login: "الايميل او كلمة المرور غير صحيحة",
      Login_Btn: "تسجيل الدخول",
      LINK: "الرابط",
      IS_REQUIRED: "مطلوب",
      ALLOWED_ACCOUNTS: "الحسابات المسموح بها",
      VERSION_NO: "رقم الاصدار",
      UPDATES: "التحديثات",
      Permissions: "الصلاحيات",
      PERMISSION_NAME: "اسم الصلاحية",
      USER_NAME: "اسم المستخدم",


      Edit: "تعديل",
      Delete: "حذف",
      ////////////////// PERMISSIONS //////////////////
      SHOW_AND_HIDE_ITEM: "اخفاء واظهار المنتجات",
      ENABLE_SHOW_PREVIEW_CLIENT_BALANCE: "عرض رصيد العميل السابق",
      MAIN_PERMISSIONS: "الصلاحيات الرئيسية",
      ENABLE_VISITOR: "الزيارات",
      ENABLE_CLIENT: "العملاء",
      ENABLE_SALES: "المبيعات",
      ENABLE_RETURN_SALES: "فاتورة استرجاع المبيعات",
      ENABLE_CLIENT_BALANCE: "سجل رصيد العميل",
      ENABLE_ACCOUNTING: "الحسابات",
      ENABLE_PRODUCT: "المنتجات",
      ENABLE_REPORTING: "التقارير",
      ENABLE_VIEW_DELIVERY_ORDERS: "طلبات التوصيل",
      ENABLE_EDIT_ORDER_AFTER_PUBLISH: "تعديل الفواتير بعد الرفع",
      ENABLE_VIEW_ORDER_AFTER_ACCEPT: "مشاهدة الفواتير المرسلة",
      ENABLE_VIEW_SYSTEM_ORDER: "مشاهدة فواتير النظام",
      ENABLE_APPLICATION_STATUS: "حالة التطبيق",
      ENABLE_RETURN_SALES: "فاتورة مرتجعات",
      ////////////////// SALE PERMISSIONS //////////////////
      ENABLE_OFFERS: "العروض",
      ENABLE_IS_PAYMENT_NEGATIVE: "منع البيع بالسالب",
      ENABLE_DELIVERY_AREA: "مناطق التوصيل اجباري",
      ENABLE_SAVE_SALES: "حفظ الفاتورة",
      ENABLE_EDIT_SALES: "تعديل الفاتورة",
      ENABLE_DELETE_SALES: "حذف الفاتورة",
      ENABLE_LOCATION_REQUIRED: "ادخال الموقع اجباري",
      ENABLE_CHANGE_PRICE_TYPE: "تغيير سعر البيع",
      ENABLE_DISCOUNT: "الخصم",
      ENABLE_FREE_ITEM: "كميات مجانية",
      ENABLE_CHECK_CLIENT_PHONE: "منع العميل من الطلب اكثر من مرة في نفس اليوم",
      ENABLE_PHONE_REQUIRED: "ادخال رقم الهاتف اجباري",
      ENABLE_NOT_BRING_CLIENT_PHONE: "عدم جلب رقم العميل",
      CHECK_MANDOOB_LOCATION_ON_CHANGE_INVOICE_STATUS:
        "تحقق من موقع المندوب عند تغيير حالة الفاتورة",


      ////////////////// CLINET PERMISSIONS //////////////////
      ENABLE_ADD_CLIENT: "اضافة عميل",
      ENABLE_ALLOW_EDIT_CLIENT_BEFORE_PUBLISH: "السماح بتعديل العميل قبل الرفع",
      ENABLE_CUSTOMER_TRANSACTIONS: "ملخص حركات العميل",


      ////////////////// ACCOUNT PERMISSIONS //////////////////
      ENABLE_ADD_SANAD_DOLLAR: "اضافة سند دولار",
      ENABLE_ADD_SANAD_DINAR: "اضافة سند دينار",
      ENABLE_SAVE_SANAD: "حفظ سند",
      ENABLE_EDIT_SANAD: "تعديل سند",
      ENABLE_DELETE_SANAD: "حذف سند",
      ENABLE_CLIENT_BALANCE: "سجل ارصدة العملاء",
      ENABLE_INSERT_NOTE_FOR_CLIENT: "اضافة ملاحظة للعميل",

      ////////////////// REPORT PERMISSIONS //////////////////
      ENABLE_DETAILED_MATERIAL_SALES_REPORT: "تقرير مبيعات مواد تفصيلي",
      ENABLE_SALES_REPORT: "تقرير مبيعات مواد بعد الرفع",
      ENABLE_SALE_ITEM_BEFORE_PUBLISH: "تقرير مبيعات مواد قبل الرفع",
      ENABLE_STORE_ITEM_REPORT: "جرد اسعار المخازن",
      ENABLE_CUSTOMER_DEBIT_REPORT: "تقرير ديون عملاء",
      ////////////////// APPLICAION STATUS PERMISSION //////////////////
      ENABLE_APPLICATION_STATUS_OFFLINE: "OFFLINE",
      ENABLE_APPLICATION_STATUS_ONLINE: "ONLINE",
      ENABLE_CHANGE_APPLICATION_STATUS: "تغيير حالة التطبيق",
      ENABLE_IS_OFFLINE: "OFFLINE",
      ////////////////// PERMISSIONS //////////////////
      Search_Account_By_Pin_Code: "البحث عن حساب",
      PIN_CODE: "المعرف",
      INVOICE_NO: "رقم الفاتورة",
      EXPIRE_DATE: "تاريخ الانتهاء",
      ACTIVE: "الحالة",
      MAX_COUNT: "عدد المستخدمين",
      View_Sub_Accounts: "عرض حسابات المستخدمين",
      DEVICE_ID: "معرف الجهاز",
      IS_BLOCK: "محظور",
      Confirm_msg_UnBlock: "هل انت متاكد ؟ \n سوف يتم فك الحظر \n",
      Confirm_msg_Block: "هل انت متاكد ؟ \n سوف يتم حظر \n",
      UnBlocked_Successfully: "تم فك الحظر بنجاح",
      Blocked_Successfully: "تم حظر الحساب بنجاح",
      ACCOUNT: "الحسابات",
      Select_Permission_Package: "حدد باقة الصلاحيات",
      save: "حفظ",
      Logout: "تسجيل الخروج",

    },
  },

};

export default resource;
